export default [
  {
    for: 'article',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: false,
      unlockEntity: false,
      blockEntity: false,
    },
    options: {
      canViewMetaData: false,
      canViewVariants: false,
    },
  },
  {
    for: 'artist',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: false,
      unlockEntity: false,
      blockEntity: false,
    },
    options: {
      canViewMetaData: false,
      canViewVariants: false,
    },
    excludedProperties: [
      'alternativeLabels',
      'artistFunctions',
      'assetIdEyecatcher',
      'categories',
      'collections',
      'colorArtist',
      'contactPeople',
      'dateBirth',
      'dateDeath',
      'divisions',
      'mmcIds',
      'mmcIdSeries',
      'products',
      'promotionImage',
      'showHome',
      'showSpotifyPlaylistGenerator',
      'stories',
      'taxa',
      'text',
      'visibleInList',
    ],
  },
  {
    for: 'asset',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: false,
      unlockEntity: false,
      blockEntity: false,
    },
    options: {
      canViewMetaData: false,
      canViewVariants: false,
    },
    excludedProperties: [
      'channelsAdditive',
      'channelsExcluded',
      'channelsExclusive',
      'subHeadline',
      'taxa',
    ],
  },
  {
    for: 'audioplayer',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: false,
      unlockEntity: false,
      blockEntity: false,
    },
    options: {
      canViewMetaData: false,
      canViewVariants: false,
    },
    excludedProperties: ['audioplayerShops'],
  },
  {
    for: 'calendar-event',
    actions: {
      create: false,
      update: false,
      read: false,
      delete: false,
      unlockEntity: false,
      blockEntity: false,
    },
    options: {
      canViewMetaData: false,
      canViewNavigation: false,
      canViewVariants: false,
    },
  },
  {
    for: 'collection',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: false,
      unlockEntity: false,
      blockEntity: false,
    },
    options: {
      canViewMetaData: false,
      canViewVariants: false,
    },
    excludedProperties: [
      'channelsAdditive',
      'channelsExcluded',
      'channelsExclusive',
      'subHeadline',
    ],
  },
  {
    for: 'content-item',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'contest',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'coop-partner',
    actions: {
      create: false,
      update: false,
      read: false,
      delete: false,
      unlockEntity: false,
      blockEntity: false,
    },
    options: {
      canViewMetaData: false,
      canViewNavigation: false,
      canViewVariants: false,
    },
  },
  {
    for: 'job',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: false,
      unlockEntity: false,
      blockEntity: false,
    },
    options: {
      canViewMetaData: false,
      canViewVariants: false,
    },
  },
  {
    for: 'link',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: false,
      unlockEntity: false,
      blockEntity: false,
    },
    options: {
      canViewMetaData: false,
      canViewVariants: false,
    },
  },
  {
    for: 'live-event',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: false,
      unlockEntity: false,
      blockEntity: false,
    },
    options: {
      canViewMetaData: false,
      canViewVariants: false,
    },
    excludedProperties: [
      'channelsAdditive',
      'channelsExcluded',
      'channelsExclusive',
      'seoTitle',
      'seoDescription',
      'seoImage',
      'dgg',
      'internalRemarks',
      'ownedByChannel',
      'repertoire',
      'secret',
      'tbc',
      'text',
    ],
  },
  {
    for: 'live-partner',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: false,
      unlockEntity: false,
      blockEntity: false,
    },
    options: {
      canViewMetaData: false,
      canViewVariants: false,
    },
  },
  {
    for: 'media-embed',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: false,
      unlockEntity: false,
      blockEntity: false,
    },
    options: {
      canViewMetaData: false,
      canViewVariants: false,
    },
    excludedProperties: ['backgroundColor', 'backgroundImage'],
  },
  {
    for: 'media-event',
    actions: {
      create: false,
      update: false,
      read: false,
      delete: false,
      unlockEntity: false,
      blockEntity: false,
    },
    options: {
      canViewMetaData: false,
      canViewNavigation: false,
      canViewVariants: false,
    },
  },
  {
    for: 'media-partner',
    actions: {
      create: false,
      update: false,
      read: false,
      delete: false,
      unlockEntity: false,
      blockEntity: false,
    },
    options: {
      canViewMetaData: false,
      canViewNavigation: false,
      canViewVariants: false,
    },
  },
  {
    for: 'mlp',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: false,
      unlockEntity: false,
      blockEntity: false,
    },
    options: {
      canViewMetaData: false,
      canViewVariants: false,
    },
    excludedProperties: [
      'cmsState',
      'isMultiArtistPage',
      'options.customJs',
      'options.customOptions',
      'options.template',
      'sso',
      'shopifyStore',
      'shopifyHasCartPage',
      'template',
      'theme',
      'thumbnail',
      'vhost',
      'version',
      'channel',
    ],
  },
  {
    for: 'mlp-page',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'newsletter',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'product',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: false,
      unlockEntity: false,
      blockEntity: false,
    },
    options: {
      canViewMetaData: false,
      canViewVariants: false,
    },
    excludedProperties: [
      'additionalCategories',
      'articles',
      'categories',
      'categoryId1',
      'categoryId3',
      'categoryId4',
      'channelsAdditive',
      'channelsExcluded',
      'channelsExclusive',
      'compilation',
      'coverEmbargo',
      'dvdBonus',
      'dvdCountryCode',
      'dvdDuration',
      'dvdFsk',
      'dvdRatio',
      'dvdSystem',
      'internationalLabel',
      'label',
      'mmcProductId',
      'placedPrioritized',
      'prizeDe',
      'productPhysId',
      'productPhysCategoryId1',
      'recommendedProducts',
      'recommendedTracks',
      'shortUrls',
      'soundEmbargo',
      'subheadline',
      'taxa',
      'trackEmbargo',
      'useProdElemConf',
      'videos',
      'voeTba',
    ],
  },
  {
    for: 'story',
    actions: {
      create: false,
      update: false,
      read: false,
      delete: false,
      unlockEntity: false,
      blockEntity: false,
    },
    options: {
      canViewMetaData: false,
      canViewNavigation: false,
      canViewVariants: false,
    },
  },
  {
    for: 'short-url',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: false,
    },
    options: {
      canViewMetaData: false,
    },
  },
  {
    for: 'teaser',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: false,
      unlockEntity: false,
      blockEntity: false,
    },
    options: {
      canViewMetaData: false,
      canViewVariants: false,
    },
    excludedProperties: [
      'channelsAdditive',
      'channelsExcluded',
      'channelsExclusive',
      'taxa',
    ],
  },
  {
    for: 'taxonomy',
    actions: {
      create: false,
      update: false,
      read: false,
      delete: false,
      unlockEntity: false,
      blockEntity: false,
    },
    options: {
      canViewMetaData: false,
      canViewNavigation: false,
      canViewVariants: false,
    },
  },
  {
    for: 'trade-partner',
    actions: {
      create: false,
      update: false,
      read: false,
      delete: false,
      unlockEntity: false,
      blockEntity: false,
    },
    options: {
      canViewMetaData: false,
      canViewNavigation: false,
      canViewVariants: false,
    },
  },
  {
    for: 'url-alias',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: false,
      unlockEntity: false,
      blockEntity: false,
    },
    options: {
      canViewMetaData: false,
      canViewNavigation: false,
      canViewVariants: false,
    },
  },
];
